
export default function dealObjectValue(obj: object){
    var param = {};
    if (obj === null || obj === undefined) return param;
    for (var key in obj) {
        if (
            obj[key] !== null &&
            obj[key] !== undefined &&
            obj[key] !== '' &&
            obj[key].length !== 0
        ) {
            param[key] = obj[key];
        }
    }
    if(obj.keyword === ''){
        param.keyword = ''
    }

    return param;
};
 